import { render, staticRenderFns } from "./government.vue?vue&type=template&id=0c43b8d0&scoped=true"
import script from "./government.vue?vue&type=script&lang=js"
export * from "./government.vue?vue&type=script&lang=js"
import style0 from "../asset/css/login.scss?vue&type=style&index=0&id=0c43b8d0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c43b8d0",
  null
  
)

export default component.exports